"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreSonarObjectsApplicationsAsyncSlice = void 0;
const _api_1 = require("../../../api/index.js");
const actions_1 = require("../../data-security/applications/_idMap/actions.js");
const actions_2 = require("../_idMap/actions.js");
const xuder_1 = require("@sonar-software/xuder");
exports.getCoreSonarObjectsApplicationsAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request, response) => (0, actions_2.updateSonarObjectReferences)([
                {
                    ingestedBy: response.results
                        .filter((entry) => entry.read)
                        .map((entry) => entry.integratedAppId),
                    populatedBy: response.monitored ?
                        response.results
                            .filter((entry) => entry.write)
                            .map((entry) => entry.integratedAppId) :
                        [-1],
                    sonarObjectId: request.sonarObjectId
                }
            ])
        ],
        successDataActionCreators: [
            (response) => (0, actions_1.updateApplicationReferences)(response.results.map((entry) => ({
                applicationId: entry.integratedAppId,
                label: entry.label,
                name: entry.name
            })))
        ]
    },
    name: 'CoreSonarObjectsApplications',
    receive: true,
    request: true,
    requestHandler: _api_1.getSonarObjectApplications,
    yieldType: xuder_1.SagaYieldType.Every
});
//# sourceMappingURL=get.js.map